import {
  Box,
  Dialog,
  DialogContent,
  Stack,
  SxProps,
  Theme,
  Typography,
} from "@mui/material";
import { combineSx, createStyleSheet } from "../utils/styles";
import { useCallback, useState } from "react";

import CloseIcon from "@mui/icons-material/Close";
import IconButton from "./IconButton";
import { useTranslation } from "react-i18next";

const Photo = (props: {
  url: string;
  label?: string;
  aspectRatio?: "auto" | number;
  sx?: SxProps<Theme>;
}) => {
  const { url, label, aspectRatio: aspectRatioProp, sx } = props;
  const { t } = useTranslation();
  const [showZoom, setShowZoom] = useState(false);
  const aspectRatio = aspectRatioProp || 3 / 4;

  const handleClick = useCallback(() => {
    setShowZoom(true);
  }, []);
  const handleModalDismiss = useCallback(() => {
    setShowZoom(false);
  }, []);

  return (
    <>
      <Stack direction="column" spacing={0.5}>
        <Box
          component="img"
          src={url}
          sx={combineSx(combineSx(styles.imageContainer, { aspectRatio }), sx)}
          onClick={handleClick}
        />
        {label ? (
          <Typography sx={styles.labelText} variant="detailCellTitle">
            {label}
          </Typography>
        ) : null}
      </Stack>
      <Dialog open={showZoom} onClose={handleModalDismiss}>
        <DialogContent sx={{ position: "relative" }}>
          <IconButton
            icon={<CloseIcon />}
            tooltip={t("common:close")}
            onClick={handleModalDismiss}
            sx={styles.closeButton}
          >
            <CloseIcon />
          </IconButton>
          <Box sx={styles.imageContainerZoom}>
            <Box component="img" src={url} alt={label} sx={styles.image} />
          </Box>
        </DialogContent>
      </Dialog>
    </>
  );
};

const styles = createStyleSheet({
  imageContainer: (theme) => ({
    height: 200,
    [theme.breakpoints.down("desktop")]: {
      height: 150,
    },
    backgroundColor: (theme) => theme.palette.grey[300],
    alignSelf: "start",
    objectFit: "contain",
    cursor: "pointer",
  }),
  labelText: {
    textAlign: "center",
  },
  imageContainerZoom: {
    maxHeight: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  image: {
    maxWidth: "85vw",
    maxHeight: "85vh",
    objectFit: "contain",
    display: "block",
  },
  closeButton: {
    position: "absolute",
    top: (theme) => theme.spacing(2),
    right: (theme) => theme.spacing(2),
    backgroundColor: (theme) => theme.palette.common.white,
    "&:hover": { backgroundColor: (theme) => theme.palette.grey[300] },
  },
});

export default Photo;
